"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blobatar = Blobatar;
exports.useBlobatarGaze = useBlobatarGaze;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@blobatar/react");
const gaze_1 = require("@blobatar/react/gaze");
function Blobatar({ seed, size = 24, animate = false, title, className, svgRef, }) {
    /**
     * ⚠️⚠️ **`background: false` BECAUSE THE PLATE IS ALREADY THERE.** `Avatar` draws a filled
     * circle in the member's identity hue and has since C2; letting the blobatar draw its own
     * backdrop would put a second disc inside the first, in a colour chosen from a different seed.
     *
     * ⚠️⚠️ **AND THAT SPLIT IS DELIBERATE, NOT A COMPROMISE.** The hue comes from the member id and
     * the face from the email, so somebody who changes their address keeps their colour and changes
     * only their geometry — they stay "the teal one" on every screen. The library's own `hue` takes
     * a number and our eight identity hues are design tokens, so they could not be handed over even
     * if we wanted to.
     */
    return ((0, jsx_runtime_1.jsx)(react_1.Blobatar, { name: seed, size: size, background: false, 
        /* ⚠️ `size-full` over the width/height the library writes from `size`, so the face follows
           the circle's box rather than its own idea of one. */
        className: className === undefined ? 'size-full' : `size-full ${className}`, ...(title === undefined ? {} : { title }), ...(animate === false ? { animate: false } : { animate: 'always' }), ...(svgRef === undefined ? {} : { ref: svgRef }) }));
}
/**
 * ┌─────────────────────────────────────────────────────────────────┐
 * │ C68 · The eyes follow something. The ONE layer of this library that runs JavaScript. │
 * └─────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **THE RETURN TYPE IS WRITTEN OUT HERE ON PURPOSE.** Inferring it would put
 * `@blobatar/react/gaze` in this package's emitted `.d.ts`, and that subpath needs the `paths`
 * shim `tsconfig.json` explains — which would then be needed in every consumer's tsconfig too.
 * Annotating against a local interface stops the shim at this package's edge.
 *
 * ⚠️⚠️ **A BLOBATAR LOOKS AT NOTHING UNTIL `lookAt` IS CALLED**, `'pointer'` included:
 * mounting arms the driver and asking aims it. Calling it before the face has mounted queues the
 * request rather than losing it, which is what lets one effect cover a conditionally rendered one.
 *
 * ⚠️ **It writes two custom properties and no class.** The face's `className` is composed
 * upstream from `animate` and the expression, so a framework rewrites that attribute wholesale and
 * would take an imperatively added class with it — the quiet failure where the driver keeps
 * running and the eyes simply stop.
 */
function useBlobatarGaze(options) {
    return (0, gaze_1.useGaze)(options);
}
//# sourceMappingURL=blobatar.js.map